import { render, staticRenderFns } from "./chatSubmit.vue?vue&type=template&id=00492bbc&scoped=true"
import script from "./chatSubmit.vue?vue&type=script&lang=js"
export * from "./chatSubmit.vue?vue&type=script&lang=js"
import style0 from "./chatSubmit.vue?vue&type=style&index=0&id=00492bbc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00492bbc",
  null
  
)

export default component.exports